import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=1c53802b&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"
import style0 from "./Screen.vue?vue&type=style&index=0&id=1c53802b&lang=scss&scoped=true&"
import style1 from "./Screen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53802b",
  null
  
)

export default component.exports